import styles from "./PlatformBranding.module.scss";

interface PlatformBrandingProps {
    logo?: string;
    platformName?: string;
    slogan?: string;
}

const PlatformBranding = ({
    logo,
    platformName = "Platform Name",
    slogan = "Slogan/Caption",
}: PlatformBrandingProps) => {
    return (
        <div className={styles.container}>
            <div className={styles.logoWrapper}>
                {!logo ? (
                    <div className={styles.placeholder}>Logo</div>
                ) : (
                    <img src={logo} alt="Platform Logo" className={styles.logo} />
                )}
            </div>

            <div className={styles.details}>
                <h1 className={styles.title}>{platformName}</h1>
                <p className={styles.subtitle}>{slogan}</p>
            </div>
        </div>
    );
};

export default PlatformBranding;